<template>
    <div :class="$common.getClassName('conutry-componesnts')" v-if="packagelist.countrylength > 1">
        <div :class="$common.getClassName('conutry-box')" v-if="packagelistDone">
            <div :class="$common.getClassName('title')"  @click="onCountryUpandDown()" >
                <div :class="$common.getClassName('title-l')"><i>2</i><span v-html="$t('select_pay_country')"></span></div>
                <div :class="`${$common.getClassName('title-r')} ${$common.getClassName('conutry4-small')}`">
                    <strong><img :src="getCostomCountrySign(GET_SELECTED_COUNTRY_DATA.country)" :alt="getCostomCountryName(GET_SELECTED_COUNTRY_DATA.country)"><i></i></strong>
                    <span v-html="getCostomCountryName(GET_SELECTED_COUNTRY_DATA.country)"></span>
                </div>
                <div :class="`${$common.getClassName('title-icon')}  ${upandDown ? 'down': 'up'}`"></div>
            </div>

            <div :class="`${$common.getClassName('conutry4-cont')} ${upandDown ? 'show': 'hide'}`">
                <ul>
                    <li
                        :data-key="item.country_md5_key" @click="onCountryUpandDown(item.country_md5_key);CLICK_USER_SELECTED_COUNTRY({key:item.country_md5_key,item:item});"
                        :class="item.country_md5_key===packagelist.countrySelectedStatus ? 'active' : ''"
                        v-for="item,key in getSortCountry()"><img :src="getCostomCountryImage(item.country)"
                                                                  :alt="getCostomCountryName(item.country)">
                        <span v-html="getCostomCountryName(item.country)"></span><strong><img
                            :src="getCostomCountrySign(item.country)"></strong><i></i></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    export default {
        name: 'CountryCustom2',
        components: {
        },
        data() {
            return {
                upandDown: false //false 收起，true 展开
            };
        },
        computed: {
            ...mapState(['$appConfig','$countryModuleCustomData','$common']),
            ...mapState('Module_Package',['packagelist','packagelistDone']),
            ...mapGetters('Module_Package', ['GET_SELECTED_COUNTRY_DATA','GET_COUNTRY_DATA']),
        },

        created() {},

        watch: {
            packagelistDone(){
                this.upandDown = !this.packagelist.user_nopay_log ? false : true;
            }
        },

        methods:{


            /**
             * 国家数据排序
             */
            getSortCountry(){
                let sort = {
                    MX: 0,
                    ES: 1,
                    AR: 2,
                    US: 3,
                };
                let temp = [];
                for(let key in this.GET_COUNTRY_DATA){

                    let country = this.GET_COUNTRY_DATA[key]['country'];
                    console.log(country);
                    temp[sort[country]] = this.GET_COUNTRY_DATA[key];
                }
                console.log(temp);
                return temp;
            },

            /**
             * 获取国家自定义国家名称
              * @param country
             */
            getCostomCountryName(country){
                return this.$countryModuleCustomData[country].name;
            },

            /**
             * 获取国家自定义国家图片
             * @param country
             */
            getCostomCountryImage(country) {
                return this.$countryModuleCustomData[country].imgurl;
            },

            /**
             * 获取国家自定义国家标志
             * @param country
             */
            getCostomCountrySign(country) {
                return this.$countryModuleCustomData[country].sign;
            },

            onCountryUpandDown(key) {
                if (key === this.packagelist.countrySelectedStatus) return;
                this.upandDown = !this.upandDown;
            },

            ...mapActions('Module_Package', ['GET_PACKAGE_LIST_INFO','GET_USER_LAST_PAY_INFO','CLICK_USER_SELECTED_COUNTRY']),
        }


    };
</script>

<style type="scss">
</style>



// WEBPACK FOOTER //
// website/components/country/CountryCustom2.vue